import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ContentChildren, ViewChild, ElementRef, OnChanges, ViewChildren, QueryList, AfterViewChecked, TemplateRef } from '@angular/core';
import { Action, Store } from '@ngrx/store';

import {
  DnvFeatureLayer, DnvMapState, LayerState, LayerType, SetHighlightFeature, ToggleFeaturePanel, Layer as DnvLayer,
  SetSelectedFeatureLayer, FeatureClicked
} from 'dnv-lib';
import { ExternalFeatureType, KvSection, SelectedFeatureInspection, WMRPState } from 'src/app/state-management';
import { NgxGalleryAnimation, NgxGalleryComponent, NgxGalleryOptions } from '@vinlos/ngx-gallery';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';



@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dnv-feature-info',
    templateUrl: './dnv-feature-info.component.html',
    styleUrls: ['./dnv-feature-info.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DnvFeatureInfoComponent implements OnInit, OnChanges {
  @ViewChild('featureDetails') details: ElementRef;
  @ViewChild('featureGallery') featureGallery: NgxGalleryComponent;
  @ViewChildren(NgxGalleryComponent) ngxGalleryCmpts: QueryList<NgxGalleryComponent>;

  @Input() mapState: DnvMapState;
  @Input() layerState: LayerState;
  @Input() wmrpState: WMRPState;
  @Input() kvSections: KvSection[];
  @Input() headerHeight: number;
  @Input() panelHeight: number;
  @Input() validRapFeatureLayer?: boolean = false;
  @Input() validWmrpFeatureLayer?: boolean = false;
  @Input() relatedRecords: any;
  @Input() cctvInspections: any;
  @Input() selectedCCTVInspection: any;
  @Input() cctvNotes: any;
  @Input() excludeFeaturesList: any;
  @Input() inspHeight: any;
  @Input() selectedFeatureAttachments: any;
  @Input() galleryOptions: NgxGalleryOptions;
  @Input() externalFeature: ExternalFeatureType;
  @Input() alertHidden: boolean;
  @Input() appSettings: any;
  @Input() scheduleYears: string[] = [];
  @Input() isWMRP: boolean = false;

  @Output() toggleFeature = new EventEmitter<Action>();
  @Output() highlightFeature = new EventEmitter<{ url: string, objectId: number }>();
  @Output() closePanel = new EventEmitter();
  @Output() selectFeature = new EventEmitter<{
    objectId: string, url: string, writeUrl: string,
    allowInsp: boolean, featureId: number, assetId: string
  }>();
  @Output() emitAssetToRap = new EventEmitter();
  @Output() emitAssetToWmrp = new EventEmitter<any>();
  @Output() emitCCTVInspection = new EventEmitter<any>();
  @Output() exportInspectionsEmitter = new EventEmitter<any>();

  relatedRecs: any = null;
  updateFGOpts = true;
  modal: any;

  showExclusionLayerCheckbox: boolean;
  scheduleForm: UntypedFormGroup = new UntypedFormGroup({
    replacementYear: new UntypedFormControl(),
    assetID: new UntypedFormControl(),
    addToExclusionLayer: new UntypedFormControl(),
    comments: new UntypedFormControl(null, [Validators.required])
  });

  constructor(
    private modalService: NgbModal
  ) {
  }

  ngOnInit(): void {
    //  this.kvSections = [];
  }

  ngOnChanges() {

  }

  showMultiSelect(ms: DnvMapState): boolean {
    return ms.surroundingFeatureList != null && ms.surroundingFeatureList.length > 0 && ms.selectedFeature != null;
  }

  closeRightPanel(): void {
    this.closePanel.emit();
  }

  carouselBack(): void {
    this.selectFeature.emit(null);
  }

  /*   panDown(evt: any): void {
    }

    panUp(evt: any): void {
    } */

  mouseEnter(objectId: number, featureId: number, name: string): void {
    const featureIdStr = featureId.toString();
    const layers: DnvLayer[] = this.layerState.layers
      .filter(l => l.type === LayerType.Active);  // 0 = active
    const matchingLayers: DnvFeatureLayer[] = layers
      .map(l => l.featureLayers)
      .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []) // Poor man's FlatMap
      .filter((fl: any) => Number(fl.gisLayerNum) === Number(featureIdStr) && (fl.displayName === name));

    // WMRP schedule
    if (name.toLocaleLowerCase().indexOf('schedule') > -1) {
      const tmpLyr = layers.map(l => l.featureLayers)
        .reduce((accumulator, currentValue) => accumulator.concat(currentValue), []) // Poor man's FlatMap
        .filter((fl: any) => Number(fl.gisLayerNum) === Number(featureIdStr) && (fl.uid.toLowerCase().indexOf('schedule') > -1));
      matchingLayers.push(tmpLyr[0]);
    }
    if (1 === matchingLayers.length) {
      this.highlightFeature.emit({ url: matchingLayers[0].url, objectId });
      // if (matchingLayers[0].type === 'Raster') {
      //   this.highlightFeature.emit({ url: matchingLayers[0].url, objectId });
      //   // console.log('raster: ', matchingLayers[0]);
      // } else {
      //   this.highlightFeature.emit({ url: matchingLayers[0].url + matchingLayers[0].whereClause, objectId });
      // }
    } else if (this.mapState.featureLayers.length === 1) {
      this.highlightFeature.emit({ url: this.mapState.featureLayers[0].url, objectId });
    } else if (matchingLayers.length > 1 && matchingLayers[0].uid.toLowerCase().indexOf('wmrp') > -1) {
      this.highlightFeature.emit({ url: matchingLayers[0].url, objectId });
    } else if (matchingLayers.length === 0 && this.mapState.featureLayers[0].uid.toLowerCase().indexOf('wmrp') > -1 && this.mapState.featureLayers[0].uid.toLowerCase().indexOf('schedule') > -1) {
      // if WRMP schedule then use first feature layer in mapstate.featureLayers
      this.highlightFeature.emit({ url: this.mapState.featureLayers[0].url, objectId });
    }
  }

  mouseLeave(): void {
    this.highlightFeature.emit(null);
  }

  setFeatureDetails(objectId: string, url: string, writeUrl: string, allowInsp: boolean, featureId: number, assetId: string): void {
    this.selectFeature.emit({ objectId, url, writeUrl, allowInsp, featureId, assetId });
  }

  expandPanel(evt: any): void {
    // console.log(evt);
  }

  addAssetToRap() {
    this.emitAssetToRap.emit();
  }

  addAssetToExclusionLayer() {
    this.emitAssetToWmrp.emit(this.scheduleForm.value);
  }

  getInspectJobVals(attr: string[][]): { jobDate: string, assetId: string } {
    let assetId = '';
    let jobDate = '';
    for (const at of attr) {
      if (at[0].toLowerCase() === 'asset_id') {
        assetId = at[1];
      }
      if (at[0].toLowerCase() === 'date') {
        jobDate = at[1];
      }
    }
    return {
      jobDate, assetId
    };
    // return 'Inspected: ' + jobDate + '<br/>Asset: ' + assetId + '<br/>Job:' + jobNum;
  }

  selectInspection(evt: any) {
    this.emitCCTVInspection.emit(evt);
  }

  countRecords(records: any) {
    if (!records) return 0;
    let total = 0;
    for (let rec of records) {
      if (rec && rec.records) {
        total = total + rec.records.length;
      }
    }
    return total;
  }

  updateGalleryOpts(): void {
    // console.log(this.ngxGalleryCmpts);
    for (let gal of this.ngxGalleryCmpts) {
      if (gal.images.length === 1) {
        gal.currentOptions.thumbnails = false;
        gal.currentOptions.imageArrows = false;
      }
    }
  }

  exportInspections(evt: any): void {
    this.exportInspectionsEmitter.emit(evt);
  }

  isEnerGovLayer(): boolean {
    return this.mapState.selectedFeatureLayer.url.toLowerCase().indexOf('energov') > -1;
  }

  getEnerGovLink(record: any): string {
    const tblName = this.relatedRecords[0].tblName.toLowerCase();
    let lnkUrl = '';
    let guid = '';
    if (tblName.indexOf('plan') > -1) {
      lnkUrl = this.appSettings['environment.pLink'];
      guid = record.filter((r: any) => r[0] === 'Plan ID')[0][1];
    } else if (tblName.indexOf('permit') > -1) {
      lnkUrl = this.appSettings['environment.permitLink'];
      guid = record.filter((r: any) => r[0] === 'Permit ID')[0][1];
    }
    else if (tblName.indexOf('code case') > -1) {
      lnkUrl = this.appSettings['environment.ccLink'];
      guid = record.filter((r: any) => r[0] === 'Code Case ID')[0][1];
    } else if (tblName.indexOf('licenses') > -1) {
      lnkUrl = this.appSettings['environment.blLink'];
      guid = record.filter((r: any) => r[0] === 'License ID')[0][1];
    }

    return lnkUrl + guid;
  }

  getEnerGovNumber(record: any): string {
    // console.log(record);
    return record.filter((r: any) => r[0].toLowerCase().indexOf('number') > -1)[0][1];
  }


  isSchedule(): boolean {
    const objId = this.mapState?.selectedFeature?.find((sf: any) => sf[0].toLowerCase().indexOf('objectid') > -1);
    return objId && this.isWMRP && this.wmrpState.selectedReplacementSchedule !== null ? true : false;
  }

  getAssetID(): string {
    const assetID = this.mapState?.selectedFeature?.find((sf: any) => sf[0].toLowerCase().indexOf('watermain_id') > -1);
    return assetID ? assetID[1] : '';
  }

  getReplacementYear(): string {
    // todo: mapstate.selectedFeature is not updated when the schedule year is updated
    // const replacementYear = this.mapState?.selectedFeature?.find((feature: string[]) => feature[0].toLowerCase().indexOf('replacement_year') > -1);
    const replacementYear = this.kvSections?.find(s => s.title.toLowerCase() === 'schedule results').kvPair.find(pair => pair[0].toLowerCase() === 'replacement year');
    return replacementYear[1] ? replacementYear[1] : 'Unscheduled';
  }

  getComments(): string {
    const comments = this.kvSections?.find(s => s.title.toLowerCase() === 'schedule results').kvPair.find(pair => pair[0].toLowerCase() === 'deferral reason');
    return comments[1] ? comments[1] : "";
  }

  openScheduleModal(modal: TemplateRef<any>) {
    this.showExclusionLayerCheckbox = this.getReplacementYear().toLowerCase() === 'unscheduled';

    this.scheduleForm.get('assetID').setValue(this.getAssetID());
    this.scheduleForm.get('assetID').disable();
    this.scheduleForm.get('replacementYear').setValue(this.getReplacementYear());
    this.scheduleForm.get('addToExclusionLayer').setValue(this.wmrpState?.exclusionLayerMains.some(asset => asset.Watermain_id === this.getAssetID()));
    this.scheduleForm.get('comments').setValue(this.getComments());

    this.scheduleForm.markAsUntouched();
    this.scheduleForm.get('comments').setErrors(null);

    this.modal = this.modalService.open(modal, { windowClass: "override-modal" });
  }

  toggleExclusionLayerCheckbox(replacementYear: string) {
    if (replacementYear.toLowerCase() === 'unscheduled') {
      this.showExclusionLayerCheckbox = true;
    } else {
      this.showExclusionLayerCheckbox = false;
    }
  }

  dismiss(): void {
    if (this.modal) {
      this.modal.dismiss();
    }
  }

  updateSchedule() {
    this.addAssetToExclusionLayer();
    console.log(this.scheduleForm.get('replacementYear').value);
    this.dismiss();
  }
}
